<mat-dialog-content class="mat-dialog--ticket">
  <app-shared-ticket *ngIf="ticketUid && serviceUid && user.uid" [ticketUid]="ticketUid" [serviceUid]="serviceUid" [user]="user" [view]="'dialog'" class="app-shared-ticket"></app-shared-ticket>
</mat-dialog-content>
